/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteDocumentRequest = {
  /**
   * The id of the document.
   */
  documentId: string;
  /**
   * If true, performs document deletion asynchronously
   */
  async?: boolean | null | undefined;
  /**
   * An optional partition to scope the request to. If omitted, accounts created after 1/9/2025 will have the request scoped to the default partition, while older accounts will have the request scoped to all partitions. Older accounts may opt in to strict partition scoping by contacting support@ragie.ai. Older accounts using the partitions feature are strongly recommended to scope the request to a partition.
   */
  partition?: string | null | undefined;
};

/** @internal */
export const DeleteDocumentRequest$inboundSchema: z.ZodType<
  DeleteDocumentRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  document_id: z.string(),
  async: z.nullable(z.boolean()).optional(),
  partition: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    "document_id": "documentId",
  });
});
/** @internal */
export type DeleteDocumentRequest$Outbound = {
  document_id: string;
  async?: boolean | null | undefined;
  partition?: string | null | undefined;
};

/** @internal */
export const DeleteDocumentRequest$outboundSchema: z.ZodType<
  DeleteDocumentRequest$Outbound,
  z.ZodTypeDef,
  DeleteDocumentRequest
> = z.object({
  documentId: z.string(),
  async: z.nullable(z.boolean()).optional(),
  partition: z.nullable(z.string()).optional(),
}).transform((v) => {
  return remap$(v, {
    documentId: "document_id",
  });
});

export function deleteDocumentRequestToJSON(
  deleteDocumentRequest: DeleteDocumentRequest,
): string {
  return JSON.stringify(
    DeleteDocumentRequest$outboundSchema.parse(deleteDocumentRequest),
  );
}
export function deleteDocumentRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteDocumentRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteDocumentRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteDocumentRequest' from JSON`,
  );
}
